window.dataLayer = window.dataLayer || [];

// Optional debug: log all dataLayer.push() calls
window.dataLayer.push = (function(originalPush) {
  return function() {
    console.log('[dataLayer PUSHED]:', arguments[0]);
    return originalPush.apply(this, arguments);
  };
})(window.dataLayer.push);


// Wait until the subscription buttons appear in the DOM
async function waitForSubscriptionButtons(selector, timeout = 3000) {
  const interval = 100;
  let waited = 0;

  while (waited < timeout) {
    const elements = document.querySelectorAll(selector);
    if (elements.length) return elements;

    await new Promise(resolve => setTimeout(resolve, interval));
    waited += interval;
  }

  throw new Error(`Timed out waiting for selector: ${selector}`);
}

document.addEventListener('ajaxProduct:added', async (data) => {
  console.log('renderAndShowItems Test');

  const item = data?.detail?.json?.items?.[0];
  if (!item) {
    console.warn('No product data found in ajaxProduct:added event');
    return;
  }

  const productID = item.id;
  console.log('Product ID from event:', productID);

  // Wait until subscription buttons are availabe in the DOM
  let subscriptionButtons;
  try {
    subscriptionButtons = await waitForSubscriptionButtons('.subscription-upgrade-box button');
    console.log('subscription-upgrade-box button')
  } catch (err) {
    console.warn(err.message);
    return;
  }

  subscriptionButtons.forEach(el => {
    const subscriptionProductID = el.getAttribute('data-one-time-variant');
    console.log('Subscription Box Product ID:', subscriptionProductID);

    if (String(productID) === subscriptionProductID) {
      console.log('Matching product found – firing GTM event');

      if (window.Shopify?.analytics) {
        window.Shopify.analytics.publish('view_upgrade_to_subscription', {
          ecommerce: {
            items: [
              {
                product_id: item.id,
                product_title: item.product_title,
                product_type: item.product_type,
                product_price: item.price / 100, // Convert cents to dollars
                product_vendor: item.vendor,
                promotion_id: "upsell_startkit_subscription",
                promotion_name: "Startkit subscription upsell",
                creative_name: "Cart upsell module",
                creative_slot: "main-cart"
              }
            ]
          }
        });
      }
    }
  });
});